import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, Container, Form, FormField, Input, Link, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneSearch, mdiAirplaneTakeoff } from '@mdi/js';
import Icon from '@mdi/react';
import ConfirmDelete from '../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getAirport, getCookie, getDate, getTime, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';

export const FlightsDeletePage = () => {
    //const storeAdmin = useStoreAdmin();
    const [idFlight, setIdFlight] = useState(0)
    const [showDeleteDialog, setShowDeleteDialog] = useState(false)
    const [flight, setFlight] = useState<ItemFlight>({} as ItemFlight);
    const { data, parameters, idAirport, menu } = useGlobalState();
    useEffect(() => {
        setIdFlight(0);
        setFlight({} as ItemFlight);
        setParameters({ ...parameters, idFlight: 0 });
    }, [idAirport]);

    const handleDeleteFlight = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/delete',
                },
                body: JSON.stringify({ idFlight: idFlight }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification("Vuelo eliminado correctamente", "success", setData);
                setFlight({} as ItemFlight);
                setIdFlight(0);
                setParameters({ ...parameters, idFlight: 0 });
            } else {
                addNotification("Error al eliminar el vuelo: " + dataWeb.status, "error", setData);
            }
            setShowDeleteDialog(false);
        } catch (error: any) {
            addNotification("Error al contactar el servidor: " + error.message, "error", setData);
        } finally {
            setLoading(false)
        }
    };
    const handleGetFlight = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/get',
                },
                body: JSON.stringify({
                    idFlight: parameters.idFlight
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (!dataWeb.flight.idFlight) {
                    addNotification("Vuelo no encontrado", "warning", setData);
                    setFlight({} as ItemFlight);
                    setIdFlight(0);
                } else {
                    setFlight(dataWeb.flight);
                    console.log(getDate(dataWeb.flight.arrivalTimeReal));
                }
            }
        } catch (error: any) {
            addNotification("Error al contactar el servidor: " + error.message, "error", setData);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (parameters.idFlight > 0) {
        }
    }, [parameters.idFlight]);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description={flight && flight.idFlightAODB > 0 ? `ID RMS ${flight.idFlightAODB}` : ""}>Eliminación de vuelo</Header>
                    <Container>
                        <SpaceBetween size="m" direction='horizontal'>
                            <FormField label="ID Flight">
                                <Input type='number' value={parameters.idFlight == 0 ? "" : parameters.idFlight} onChange={(e) => {
                                    if (parseInt(e.detail.value) == 0) return;

                                    setParameters({
                                        ...parameters,
                                        idFlight: parseInt(e.detail.value)
                                    })
                                }} placeholder="" />
                            </FormField>
                            <FormField label="&nbsp;">
                                <Button
                                    disabled={!parameters.idFlight || parameters.idFlight.toString().length <= 5}
                                    variant="primary" onClick={() => {
                                        if (parameters.idFlight > 0) {
                                            setIdFlight(parameters.idFlight);
                                            handleGetFlight();
                                        }
                                    }}><Icon path={mdiAirplaneSearch} size={1} /></Button>
                            </FormField>
                        </SpaceBetween>
                    </Container>
                    {flight && flight.idFlight && flight.idAirportOrigin && (
                        <div style={{ maxWidth: 950 }}>
                            <Form actions={
                                <SpaceBetween size="m" direction='horizontal'>
                                    <Button variant="link" onClick={() => { setFlight({} as ItemFlight); setParameters({ ...parameters, idFlight: 0 }); }}>Cancelar</Button>
                                    <Button variant="primary" onClick={() => {
                                        setShowDeleteDialog(true);
                                    }}>Eliminar</Button>
                                </SpaceBetween>}>
                                <SpaceBetween size="m" direction='vertical'>
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <div style={{ maxWidth: 400 }}>
                                            <Container>
                                                <div style={{ alignItems: "center" }}>
                                                    <SpaceBetween size="m" direction='horizontal'>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Origen" constraintText={getAirport(flight.idAirportOrigin, data).city}>
                                                                <Link variant="awsui-value-large">{getAirport(flight.idAirportOrigin, data).IATA}</Link>
                                                            </FormField>
                                                        </div>
                                                        <div style={{ width: 120 }}>
                                                            <FormField label={flight.idAirportOrigin === flight.idAirportDestination ? <Icon path={mdiAirplaneLanding} size={1} /> : <Icon path={mdiAirplaneTakeoff} size={1} />}>
                                                                <Box textAlign="center">
                                                                    <div style={{ width: 120, alignItems: "center" }}>
                                                                        <Link variant="awsui-value-large">{flight.flightNumber}</Link>
                                                                        <img src={`https://fids-bucket.s3.us-east-1.amazonaws.com/media/images/airlines/fids/${flight.idAirline || 0}.png`} style={{ width: 120, height: "auto", border: "1px solid #ccc", borderRadius: "8px" }} />
                                                                    </div>
                                                                </Box>
                                                            </FormField>

                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Destino" constraintText={getAirport(flight.idAirportDestination, data).city}>
                                                                <Link variant="awsui-value-large">{getAirport(flight.idAirportDestination, data).IATA}</Link>
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                </div>
                                            </Container>
                                        </div>

                                        <SpaceBetween size="m" direction='vertical'>
                                            <Box>
                                                <SpaceBetween size="m" direction='horizontal'>

                                                    <FormField label="Estado">
                                                        {data.statuses.find((s: any) => s.idStatus === flight.idStatus)?.statusES}
                                                    </FormField>

                                                    {idAirport === flight.idAirportOrigin ? (
                                                        <FormField label="Puerta">
                                                            {data.gates.find((g: any) => g.idGate === flight.idGate)?.gate}
                                                        </FormField>
                                                    ) : (
                                                        <FormField label="Cinta">
                                                            {data.belts.find((b: any) => b.idBelt === flight.idBelt)?.belt}
                                                        </FormField>
                                                    )}
                                                </SpaceBetween>
                                            </Box>
                                            <Box>
                                                {idAirport === flight.idAirportOrigin ? (
                                                    <SpaceBetween size="m" direction='vertical'>
                                                        <SpaceBetween size="m" direction='horizontal'>
                                                            <FormField label="Salida" constraintText={getDate(flight.departureTime)}>
                                                                {getTime(flight.departureTimeReal)}
                                                            </FormField>
                                                            <FormField label="Embarque" constraintText={getDate(flight.boardingTime)}>
                                                                {getTime(flight.boardingTimeReal)}
                                                            </FormField>
                                                        </SpaceBetween>


                                                    </SpaceBetween>
                                                ) : (

                                                    <SpaceBetween size="m" direction='horizontal'>
                                                        <FormField label="Llegada" constraintText={getDate(flight.arrivalTime)}>
                                                            {getTime(flight.arrivalTimeReal)}
                                                        </FormField>
                                                    </SpaceBetween>
                                                )
                                                }
                                            </Box>
                                        </SpaceBetween>
                                    </SpaceBetween>








                                </SpaceBetween>
                            </Form>
                        </div>
                    )}

                    <ConfirmDelete show={showDeleteDialog} confirmWord={'eliminar'} action={'Eliminar'} warning={'Esta acción no puede ser reversada'} header={`Eliminar vuelo ${idFlight}`} onDismiss={() => setShowDeleteDialog(false)} onConfirm={() => handleDeleteFlight()} />
                </SpaceBetween>

            }
        />
    )
};
